import { render } from "./BusinessSubscription.vue?vue&type=template&id=5bef03e2"
import script from "./BusinessSubscription.vue?vue&type=script&lang=js"
export * from "./BusinessSubscription.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__